import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { VisualizationThemeGitService } from './visualization-theme-git.service';

@Injectable({ providedIn: 'root' })
export class VisualizationThemeGitFactoryService extends AbstractGitFactoryService<VisualizationThemeGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: VisualizationThemeGitService,
    });
  }
}
